import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { AppIcon } from '../ui/icon'
import { mdiTicketOutline } from '@mdi/js'
import { Button } from '../ui/button'
import { Sheet, SheetContent, SheetHeader, SheetTitle } from '../ui/sheet'
import { EntityIssuesList } from '../issues/EntityIssuesList'
import { $api } from '../../api/queryClient'

type Props = {
    org: string
    docUid: string
}

export function DocumentIssuesButton({ org, docUid }: Props) {
    const { t } = useTranslation('issues')
    const [open, setOpen] = useState(false)

    const { data } = $api.useQuery(
        'get',
        '/api/v1/organizations/{orgCode}/issues',
        {
            params: {
                path: { orgCode: org },
                query: {
                    target_entity_type: 'document',
                    target_entity_uid: docUid,
                    status: 'open,in_progress',
                    assignee_uid: 'all',
                    limit: 1,
                },
            },
        },
    )
    const count = data?.total ?? 0

    return (
        <>
            <Button
                onClick={() => setOpen(true)}
                variant="outline"
                className="p-2 relative"
                title={t('list.title', { defaultValue: 'Issues' })}
                data-testid="document-issues-btn"
            >
                <AppIcon path={mdiTicketOutline} size="md" />
                {count > 0 && (
                    <span
                        className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-semibold flex items-center justify-center"
                        data-testid="document-issues-count"
                    >
                        {count > 99 ? '99+' : count}
                    </span>
                )}
            </Button>

            <Sheet open={open} onOpenChange={setOpen}>
                <SheetContent side="right" className="sm:max-w-xl flex flex-col">
                    <SheetHeader>
                        <SheetTitle>{t('list.title', { defaultValue: 'Issues' })}</SheetTitle>
                    </SheetHeader>
                    <div className="flex-1 overflow-y-auto p-4">
                        <EntityIssuesList
                            targetType="document"
                            targetEntityUid={docUid}
                            renderIssueSheet={false}
                        />
                    </div>
                </SheetContent>
            </Sheet>
        </>
    )
}
